import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonUtils } from '../../../../../shared/utils/common.utils';
import { User } from '../../../admin/manage-users/shared/user.model';
import { AuthService } from '../../../../../core/services/auth.service';
import { UserService } from '../../../admin/manage-users/shared/user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss'],
    standalone: false
})
export class ChangePasswordFormComponent implements OnInit, AfterViewInit {
  newPassword: string;
  confirmedPassword: string;
  submitted = false;

  currentUserInfo: User;
  currentUsername: string;

  private successMessage: string;
  private errorMessage: string;
  private errorCheckingUserInfoMessage: string;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private toastrService: ToastrService,
    private routerService: Router,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {}

  // TODO: Refactor by adding a npm packages for the password validator
  get passwordConfirmed(): boolean {
    return this.newPassword === this.confirmedPassword;
  }
  get isImpersonated() {
    return this.authService.isImpersonated();
  }
  get allDataAvailable(): boolean {
    return !!this.newPassword && !!this.confirmedPassword;
  }

  ngOnInit() {
    this.setupTranslations();
  }

  ngAfterViewInit() {
    const user = this.authService.getUserInfo();
    this.currentUsername = user.preferred_username;

    this.userService
      .getSingleUserByUsername()
      .toPromise()
      .then(
        userInfo => {
          this.currentUserInfo = userInfo;
        },
        error => {
          this.toastrService.error(this.errorCheckingUserInfoMessage);
        },
      );
  }

  confirm() {
    this.submitted = true;
    if (!this.validate()) {
      return;
    }
    this.userService
      .updatePassword(this.currentUserInfo, this.newPassword)
      .subscribe(
        _ => {
          this.toastrService.success(this.successMessage);
          this.routerService.navigateByUrl('secure/dashboard');
        },
        error => {
          if (error.error === 'OLD-PASSWORD-INCORRECT') {
            this.cdr.detectChanges();
          } else {
            this.toastrService.error(this.errorMessage);
            this.resetForm();
            this.cdr.detectChanges();
          }
        },
      );
  }

  resetForm() {
    this.newPassword = '';
    this.confirmedPassword = '';
  }

  validate(): boolean {
    if (!this.passwordConfirmed) {
      return false;
    }
    return true;
  }

  private setupTranslations(): void {
    this.translateService
      .get('PASSWORD-CHANGE.PASSWORD-CHANGE-SUCCESS')
      .subscribe(t => (this.successMessage = t));
    this.translateService
      .get('PASSWORD-CHANGE.PASSWORD-CHANGE-ERROR')
      .subscribe(t => (this.errorMessage = t));
    this.translateService
      .get('PASSWORD-CHANGE.ERROR-CHECKING-USER-INFO')
      .subscribe(t => (this.errorCheckingUserInfoMessage = t));
  }
}
